import React from 'react'
import { InfoActivityStyle } from './info-activity-style'
import { InfoActivityView } from './info-activity-view'

export const InfoActivityContainer: React.FC<React.ComponentProps<typeof InfoActivityView>> = ({ ...rest }) => {
  return <InfoActivityStyle {...rest} />
}
